import React, { useEffect, useState } from "react";
import TeamService from "services/TeamService";
import StatsCard from "components/StatsCard";
import NetThrivingScoreStatsDetails from "./NetThrivingScoreStatsDetails";

export default ({ team_id, showPublishVideo = true }) => {
  const [stats, setStats] = useState({});
  const [time, setTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [detailsOpened, setDetailsOpened] = useState(false);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await TeamService.getNetThrivingScoreStats(
          team_id,
          time
        );

        setStats(response?.data?.data);
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();

    //eslint-disable-next-line
  }, [team_id, time]);

  return (
    <>
      <StatsCard
        title="Team Statistics"
        backgroundClass="card-blue"
        loading={loading}
        stats={stats}
        setTime={setTime}
        onDetailsOpen={() => setDetailsOpened(true)}
        onDetailsClosed={() => setDetailsOpened(false)}
        netThriving={true}
      >
        <NetThrivingScoreStatsDetails
          showPublishVideo={showPublishVideo}
          stats={stats}
          team_id={team_id}
          opened={detailsOpened}
        />
      </StatsCard>
    </>
  );
};
